//Helpers
import { isCamera, isShellyPresence } from 'src/helpers/interface_helpers';
import { isXT1Module } from 'src/helpers/xt1_helpers/template_helpers';
import { isVirtualDevice } from 'src/helpers/virtual_helpers/virtual_components_helpers';
import { isSupportedMethodByChannel } from '../../local/supported/local_action_supported_helpers';
import { isPeripheralDevice } from 'src/helpers/addons/addon_device_helpers';
import { isCameraLocalActionMethod } from 'src/helpers/actions/local/devices/camera_local_actions';
import { devices_settings } from 'src/stores';
// Types
import type { Device } from 'src/types/Device';
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';
import type { Peripheral } from 'src/types/Peripherals';

export const isSupportedScheduleMethod = (method: string): boolean => {
	method = method.split(':')[0];
	return (
		/^(switch|rgbw?|light|cct|rgbcct|cb)\.(set|toggle)$/i.test(method) ||
		/^(rgbcct)\.(setconfig)$/i.test(method) ||
		/^cover\.(open|close|gotoposition|stop)$/i.test(method) ||
		/^blutrv\.(call|target|boost|position)$/i.test(method) ||
		/^cury\.(boost|set|setconfig)$/i.test(method) ||
		/^presencezone\.(setconfig)$/i.test(method) ||
		isCameraLocalActionMethod(method) ||
		isSupportedVirtualMethod(method)
	);
};

export const isSupportedVirtualMethod = (method: string): boolean => {
	method = method.split(':')[0];
	return /^(boolean|enum|text|number)\.set$/i.test(method) || /^button.trigger$/i.test(method);
};

export const filterScheduleMethodByChannel = (
	device: Device,
	job: ActionJob,
	switchPeripheral: Peripheral,
	deviceChannel: number,
): boolean => {
	const method = job?.method;
	const normalizedMethod = method?.toLowerCase();
	if (isVirtualDevice(device.type) || isXT1Module(device.type)) {
		return isSupportedVirtualMethod(method);
	} else if (switchPeripheral) {
		if (isPeripheralDevice(device.type)) {
			return job?.params?.id === switchPeripheral?.sensor?.extid;
		}
		return !isSupportedVirtualMethod(method);
	} else if (isShellyPresence(device.type)) {
		return !isSupportedVirtualMethod(method);
	} else if (isCamera(device.type) && /^(Camerazone.Setconfig)$/i.test(method)) {
		return true;
	}
	return (
		isSupportedMethodByChannel(device, job, deviceChannel) ||
		(deviceChannel < 100 && /^(Shelly.Update)$/i.test(method))
	);
};
